export default __webpack_public_path__ + "static/media/Pin_Job_Winch.d23a69e0.svg";